import { Pipe, PipeTransform, Injectable } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'formatdate',
  pure: true
})

@Injectable({
  providedIn: 'root',
})

export class DateFormatPipe implements PipeTransform {

  transform(item: string): string {
    if (!item) {
      return '';
    }

    return moment(item, 'YYYY-MM-DD').format('MM/DD/YYYY');
  }

}
